'use strict';

import 'angular';

import servicesModule from '../../services';
import incidentDirective from './directive';

var MODULE_NAME = 'daupler.incidents.components.incident';

var app = angular.module(MODULE_NAME, [
	servicesModule,
]);
app.directive('incident', incidentDirective);

export default MODULE_NAME;
